<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="EquipmentId"
      ref="list"
      unit="模具使用管理"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :get-data-func="getDataFunc"
      :query-params="params"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ba/mould").default,
      params: {
        JobName: "",
        Status: null,
      },
    };
  },
  methods: {
    getDataFunc(params = {}) {
      return new Promise((resolve) => {
          resolve({ Count: 2, Data: [
            { Id: 1, mjbm: "MJ25003", nqgg: "1出4腔", lx: 0, czlx: 0, czsj: "2025-07-15", xgry: "测试人员" },
            { Id: 2, mjbm: "MJ25004", nqgg: "1出8腔", lx: 1, czlx: 1, czsj: "2025-08-10", xgry: "测试人员" },
          ]});
      });
    },
    onExport() {
      // var loading = this.$loading({
      //   lock: true,
      //   text: "正在导出...",
      //   spinner: "el-icon-loading",
      //   customClass: "my_loading",
      //   background: "rgba(0, 0, 0, 0.3)",
      // });
      // this.api.export(this.params).then(() => {
      //   loading.close();
      // });
    },
    delRange(ids) {
      // this.api.delete({ ids }).then((res) => {
      //   if (res.Code == 0) {
      //     this.$message.success("删除成功");
      //     this.reload();
      //   } else {
      //     this.$message.error(res.Msg);
      //   }
      // });
    },
  },
};
</script>